import { BRANDS } from "../config/brands";

function MarqueeContent() {
    return (
        <div className="flex shrink-0 items-center">
            {BRANDS.map((b) => (
                <span key={b.id} className="flex items-center gap-3">
                    <img
                        src={b.logo}
                        alt=""
                        aria-hidden="true"
                        loading="lazy"
                        className={
                            b.logoShape === "wide"
                                ? "h-7 w-auto max-w-[90px] object-contain"
                                : "h-8 w-8 rounded-full object-cover ring-1 ring-amber-400/30"
                        }
                    />
                    {b.id === "truth-insurance" ? (
                        <a
                            href={b.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="font-display text-sm tracking-[0.3em] whitespace-nowrap text-slate-400 uppercase transition-colors hover:text-amber-300 sm:text-base"
                            aria-label="Truth Insurance — Visit Website (opens in a new tab)"
                        >
                            {b.name}
                        </a>
                    ) : (
                        <span className="font-display text-sm tracking-[0.3em] whitespace-nowrap text-slate-400 uppercase transition-colors sm:text-base">
                            {b.name}
                        </span>
                    )}
                    <span className="marquee-diamond" aria-hidden="true" />
                </span>
            ))}
        </div>
    );
}

export default function Marquee() {
    return (
        <section
            aria-label="Truth Excellence Group brand ticker"
            className="relative border-y border-amber-400/10 bg-[#0A0B10]/60 py-6"
        >
            <div className="overflow-hidden">
                <div className="marquee-track">
                    <MarqueeContent />
                    <MarqueeContent />
                </div>
            </div>
            <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#050507] to-transparent" />
            <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#050507] to-transparent" />
        </section>
    );
}
